

export enum ExternalEnrollmentFieldCodes {
    ACCHOLDERNAME = "BankAccountHolderName",
    ACCOUNTNB = "BankAccountNumber",
    AGENTEMAIL = "AGENTEMAIL",
    AGENTFN = "BeneficiaryFirstName",
    AGENTID = "AgentID",
    AGENTLN = "BeneficiaryLastName",
    APPADD1 = "ResidenceAddressLine1",
    APPADD2 = "ResidenceAddressLine2",
    APPCITY = "ResidenceCity",
    APPDOB = "BeneficiaryBirthDate",
    APPDT = "ApplicationDate",
    APPEMAIL = "BeneficiaryEmail",
    APPFN = "BeneficiaryFirstName",
    APPGEN = "BeneficiaryGender",
    APPLN = "BeneficiaryLastName",
    APPMI = "BeneficiaryMI",
    APPST = "ResidenceState",
    APPZIP = "ResidenceZipCode",
    ATESTPROOF = "ATESTPROOF",
    AUTHREPADD1 = "POAAddress",
    AUTHREPADD2 = "AUTHREPADD2",
    AUTHREPCITY = "POACity",
    AUTHREPIND = "AUTHREPIND",
    AUTHREPNAME = "POAName",
    AUTHREPPHONE = "POAPhone",
    AUTHREPREL = "POARelationship",
    AUTHREPST = "POAState",
    AUTHREPZIP = "POAZipCode",
    APPPHONE = "BeneficiaryPhoneNumber",
    CELLPHONE = "BeneficiaryMobilePhone",
    COBBIN = "SecondaryCoverageRxBin",
    COBEFFDT = "SecondaryCoverageEffectiveDate",
    COBPCN = "SecondaryCoverageRxPCN",
    COBTERMDT = "SecondaryCoverageTermDate",
    COMPLETEIND = "COMPLETEIND",
    CONF = "CONF",
    CONTRACT = "CONTRACT",
    CUID = "CUID",
    CULTURE = "CULTURE",
    EFFDT = "EffectiveDate",
    EFTTYPE = "BankAccountType",
    ELECTION = "ElectionStatus",
    FININSTNAME = "BankName",
    HICN = "BeneficiaryHICNumber",
    LANG = "PreferredLanguage",
    LEGREPEMAIL = "LEGREPEMAIL",
    LTCFACILITY = "LTCName",
    LTCPHONE = "LTCPhone",
    MAILADD1 = "MailingAddressLine1",
    MAILADD2 = "MailingAddressLine2",
    MAILCITY = "MailingCity",
    MAILST = "MailingState",
    MAILZIP = "MailingZipCode",
    MEDA = "PartAEffectiveDate",
    MEDB = "PartBEffectiveDate",
    NOTES = "NOTES",
    OTHCVRG = "HasSecondaryCoverage",
    OTHCVRGGRP = "SecondaryCoverageRxGroup",
    OTHCVRGID = "SecondaryCoverageIDNumber",
    OTHCVRGNAME = "SecondaryCoveragePlanName",
    PLANNAME = "PLANNAME",
    PLANST = "PlanState",
    PLANTYPE = "PlanType",
    PLANYEAR = "PLANYEAR",
    POA = "POA",
    PWO = "PaymentMethod",
    ROUTINGNB = "BankRoutingNumber",
    SEPEFFDT = "EligibilityDate",
    SEPREASONCD = "EligibilityReasons",
    SOA = "SOAIncluded",
    SUFFIX = "BeneficiarySuffix",
    TITLE = "BeneficiaryTitle",
    DEX = "EnrollmentMethod",
    AGENTDEX = "EnrollmentMethod",
    APPSIGNEDIND = "APPSIGNEDIND",
    AUTHREPSIGNEDIND = "AUTHREPSIGNEDIND",
    ADMINID = "ADMINID",
    LEADTYPE = "LEADTYPE",
    CONTACTTYPE = "CONTACTTYPE",
    DATEOFRECEIPT = "AppRecDate",
    POVERIND = 'POVERIND',
    CC = 'CC',
    UNMTHS = 'UNMTHS',
    SECMBRID = 'SECMBRID',
    RELCD = 'RELCD',
    FAMILYID = 'FAMILYID',
    PERSONCD = 'PERSONCD',
    LANGFORMAT = 'LANGFORMAT',
    EOB = 'EOB',
    SOANOTINCLUDEDMAIL = 'SOANOTINCLUDEDMAIL',
    MAILINGADDRESSISSAME ='MailingAddressIsSame'
}

